import { useQuery } from '@tanstack/react-query';
import { lessonApi } from '@/lib/api-client';
import { queryKeys } from '@/config/query-client';
import type { BuildPlanResponse } from '@/types/api';

/** How often the plan is asked for until the outline exists. */
const PLAN_POLL_MS = 3000;

/**
 * The lesson's outline as the plan first placed it, for the build view's
 * plan card while the concepts are written up (`GET /lessons/{id}/build-plan`).
 * Polled until it has sections, then left alone: it does not change after.
 */
export function useBuildPlan(
  lessonId: string | undefined,
  { enabled }: { enabled: boolean }
): BuildPlanResponse | null {
  const { data } = useQuery({
    queryKey: queryKeys.lessons.buildPlan(lessonId ?? ''),
    queryFn: () => lessonApi.getBuildPlan(lessonId as string),
    enabled: enabled && !!lessonId,
    refetchInterval: query =>
      query.state.data?.sections?.length ? false : PLAN_POLL_MS,
    refetchOnWindowFocus: false,
    retry: 1,
  });
  return data?.sections?.length ? data : null;
}
